import axios from "axios";

const urls = {
  live: "https://api.ecoshoppegh.com",
  development: "http://localhost:5000",
};

export const baseURL = urls.live;

export const apiClient = axios.create({
  baseURL: `${baseURL}/client`,
  withCredentials: true,
  headers: { "X-Client-Host": window.location.origin },
});
